"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _DepositWorkflowsComponent = _interopRequireDefault(require("./DepositWorkflowsComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state, _ref) {
  var submitting = _ref.submitting,
    onSubmit = _ref.onSubmit;
  return {
    templateInfo: state.deposit.templateInfo,
    submitting: submitting,
    isLoading: state.deposit.isLoading,
    onSubmit: onSubmit
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps)(_DepositWorkflowsComponent["default"]);